import React from 'react';

import type { ByfunnFrapiArticle } from '../../../types/frapi-types.js';
import type { ArticleProps } from '../../components/articles/types.js';

import { ReviewArticle } from '../../components/articles/ReviewArticle/ReviewArticle.js';
import { GuideArticle } from '../../components/articles/GuideArticle/GuideArticle.js';
import { isReview } from '../../components/articles/helpers.js';

type ArticleTypeProps = {
  article: ByfunnFrapiArticle;
  commonProps: ArticleProps;
};

const FeatureArticle: React.FC<ArticleProps> = (commonProps) => (
  <GuideArticle {...commonProps} isFeature />
);

export const ArticleType: React.FC<ArticleTypeProps> = React.memo(
  function ArticleComponent({ article, commonProps }) {
    const articleLayouts = {
      automatic: isReview(article) ? ReviewArticle : GuideArticle,
      review: ReviewArticle,
      news: GuideArticle,
      feature: FeatureArticle,
    };

    const Article = articleLayouts[article.articleTemplate];

    return <Article {...commonProps} />;
  },
);

ArticleType.displayName = 'ArticleType';
